import React, { useState, useRef, useEffect } from "react";
import { FiX } from "react-icons/fi";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const UserMenu: React.FC = () => {
  const { t } = useTranslation('dashboard');
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  // Gestion clics extérieurs
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Calculer les initiales à partir du nom complet
  const initials = user?.full_name
    ? user.full_name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
    : "U";

  return (
    <div className="relative" ref={ref}>
      {/* Bouton avatar */}
      <button
        onClick={() => setOpen(!open)}
        className="w-10 h-10 rounded-full bg-blue-600 text-white font-bold flex items-center justify-center hover:bg-blue-700 transition"
      >
        {initials}
      </button>

      {/* Menu déroulant */}
      {open && (
        <div className="absolute right-0 mt-2 w-80 bg-white shadow-lg rounded-md border p-4 z-50">
          <div className="flex justify-between items-center mb-2">
            <h4 className="text-sm font-semibold text-gray-700">{t('userMenu.title')}</h4>
            <button
              className="text-gray-400 hover:text-gray-600"
              onClick={() => setOpen(false)}
            >
              <FiX />
            </button>
          </div>

          {/* Informations utilisateur */}
          <div className="mb-3">
            <p className="font-medium text-gray-900">{user?.full_name || t('userMenu.defaultName')}</p>
            <p className="text-sm text-gray-500 truncate">{user?.email || ''}</p>
            {user?.role && (
              <p className="text-xs text-gray-400 mt-1">{t('userMenu.role')} {user.role}</p>
            )}
            {user?.organization_name && (
              <p className="text-xs text-gray-400">{t('userMenu.organization')} {user.organization_name}</p>
            )}
          </div>

          {/* Actions */}
          <div className="flex justify-between mt-4">
            <button
              className="text-sm bg-gray-100 hover:bg-gray-200 px-3 py-1 rounded transition"
              onClick={() => {
                setOpen(false);
                // TODO: Navigate to account settings
              }}
            >
              {t('userMenu.myAccount')}
            </button>
            <button
              className="text-sm bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded transition"
              onClick={handleLogout}
            >
              {t('userMenu.logout')}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
